import Button from './Button';
import WithIcon from './layouts/WithIcon';
import PaperClip from 'imagesUwKluis/svg/paperclip.svg';
import {FC, useContext} from 'react';
import MessagebarContext from '../../context/MessagebarContext';
import {useTranslation} from "react-i18next";

interface Props {
  fileName: string;
  fileUrl: string;
  isDeleted?: boolean;
}

const FileAttachmentButton: FC<Props> = ({
  fileName,
  fileUrl,
  isDeleted,
}) => {
  const { t } = useTranslation();
  const { setAlertMessage } = useContext(MessagebarContext);

  const downloadAttachment = () => {
    if (!fileUrl || isDeleted) {
      setAlertMessage(
        t('Dit bestand is niet meer beschikbaar, neem contact op met je adviseur voor meer informatie.')
      );
    } else {
        window.open(fileUrl, '_blank');
    }
  };

  return (
    <Button
      variant={isDeleted ? 'disabled' : 'action-outline'}
      buttonSize="small"
      onClick={downloadAttachment}
      css={{ textDecoration: 'underline', cursor: isDeleted ? 'not-allowed' : 'pointer' }}
    >
      <WithIcon color={isDeleted ? 'border' : 'primaryFont'}>
        <PaperClip width="1rem" height="1.125rem" />
        {fileName}
      </WithIcon>
    </Button>
  );
};

export default FileAttachmentButton;
